import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';
import './Hint.sass';

const defaultDialogueConfig = {
  style: {},
  hoverDuration: 500,
  position: 'bottom'
};

class Hint extends Component {
  constructor(props) {
    super(props);
    this.state = { dialogueOpen: false };
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter() {
    const { dialogueConfig } = this.props;
    this.hoverTimeoutToken = setTimeout(() => {
      this.setState({ dialogueOpen: true });
    }, dialogueConfig.hoverDuration || defaultDialogueConfig.hoverDuration);
  }

  handleMouseLeave() {
    window.clearTimeout(this.hoverTimeoutToken);
    this.setState({ dialogueOpen: false });
  }

  render() {
    const {
      style,
      title,
      tooltipConfig,
      dialogueConfig,
      children,
      fontAwesomeIcon
    } = this.props;
    const { dialogueOpen } = this.state;
    const wrapperClassname = `dialogue-display position-${
      dialogueConfig.position || defaultDialogueConfig.position
    }`;

    return (
      <span
        ref={(c) => { this.wrapper = c; }}
        className={`Hint ${wrapperClassname} ${dialogueOpen ? 'open' : ''}`}
        style={style}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {
          <Tooltip {...tooltipConfig}>
            {
              title ?
                <span className="hint-trigger-content">{title}</span> :
                <span className={`fa fa-${fontAwesomeIcon}`} />
            }
          </Tooltip>
        }

        <div
          className="dialogue"
          style={dialogueConfig.style || defaultDialogueConfig.style}
        >
          {children}
        </div>
      </span>
    );
  }
}

Hint.propTypes = {
  tooltipConfig: PropTypes.object,
  dialogueConfig: PropTypes.shape({
    style: PropTypes.object,
    position: PropTypes.string
  }),
  style: PropTypes.object,
  children: PropTypes.any.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  fontAwesomeIcon: PropTypes.string
};

Hint.defaultProps = {
  style: {},
  tooltipConfig: {
    content: 'Hint',
    position: 'bottom',
    offset: NaN
  },
  dialogueConfig: {},
  fontAwesomeIcon: 'question-circle',
  title: null
};

export default Hint;



// WEBPACK FOOTER //
// ./src/components/Hint.jsx